import ROUTE from '@eu/app/router/appModule/names.js'
import routes from '@eu/app/router/appModule/routes'
import hooks from '@eu/app/router/appModule/hooks'

export default {
  ROUTE,
  routes,
  hooks,
}
